<button type="button" class="relative" [ngClass]="buttonClass" [disabled]="(isLoading || disabled) && !isEnabled">

    @if (isLoading) {
        <bizz-icon iconName="spinner-third" iconStyle="duotone"
                   class="absolute left-[calc(50%_-_0.5rem)] flex size-5 animate-spin items-center justify-center text-white">

        </bizz-icon>
    }

    <div [class]="{ 'invisible' :  isLoading }" class="flex flex-row items-center justify-center align-middle">
        @if(icon){
            <bizz-icon class="h-4 w-4 text-blue-500 mr-4" [iconName]="icon"></bizz-icon>
        }
        <ng-content></ng-content>
    </div>
</button>